import React from 'react';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image/index';
import { isEmptyObject, redirectToFaqPage } from 'common/utilities/utils';

export const GetHelpLandingView = props => {
  const nearStore = JSON.parse(localStorage.getItem('storeInfo')) ?? {};
  const { contentData, isLocalized, isMobile, history, onStartOrderClick } = props;
  const {
    faqSectionDetails,
    helpSectionCallDetails,
    helpSectionContactDetails,
    helpSectionHeadline,
    helpSectionNearestKFC,
    surveyDetails,
  } = contentData;
  const faqNavigate = name => {
    history.push({
      pathname: name,
    });
  };

  const contactUs = url => {
    history.push({
      pathname: url,
    });
  };
  const FaqItemClick = e => {
    console.log('clicked', e.target.textContent);
    localStorage.setItem('SelectedFaqItem', e.target.textContent);
    redirectToFaqPage(history, e.target.textContent);
  };
  const callNearStore = nearStoreInfo => {
    let phoneNumber = '';
    if (isEmptyObject(nearStoreInfo)) {
      const { contacts = [] } = nearStoreInfo;
      contacts.forEach(c => {
        const { key, value } = c;
        if (key === 'phoneNumber') {
          phoneNumber = value;
        }
      });
    }
    return phoneNumber;
  };
  return (
    <div className='get-help-section'>
      <>
        <h2 className='help-text'>{helpSectionHeadline}</h2>
        <div className='help-block-container'>
          <div className='get-help-block mr5 mb-5'>
            <h3 className='header-text'>
              <span>{helpSectionNearestKFC}</span>
            </h3>
            {!isMobile && isLocalized && (
              <>
                <div data-testid='nearest-kfc' className='nearest-kfc-details'>
                  <span className='section-text font-bold'>{nearStore?.name?.[0]?.value}</span>
                  <span className='section-text font-bold'>
                    {nearStore?.addresses?.[0]?.address?.addressLines?.[0]}
                  </span>
                  <span className='section-text font-bold'>
                    Call. <span className='deepBlack'>{callNearStore(nearStore)}</span>
                  </span>
                </div>
              </>
            )}
            {isMobile && isLocalized && (
              <div className='section-text ContactUsButton'>
                <div className='nearest-kfc-details mb-1rem'>
                  <span className='section-text font-bold'>{nearStore?.name?.[0]?.value}</span>
                  <span className='section-text font-bold'>
                    {nearStore?.addresses?.[0]?.address?.addressLines?.[0]}
                  </span>
                </div>
                <a data-testid='nearest-kfc-localised' href={`tel:${callNearStore(nearStore)}`} className='anchorTags'>
                  <ButtonComp ariaLable='' className='deepBlack font-bold button whiteButton blkBorder '>
                    <ImageComponent
                      srcFile={helpSectionCallDetails?.icon}
                      alt='desktopImage'
                      className='Messageimage'
                    />
                    Call Restaurant
                  </ButtonComp>
                </a>
              </div>
            )}
            {!isLocalized && (
              <div data-testid='find-kfc' className='section-text mt-5 ContactUsButton'>
                <ButtonComp
                  ariaLable='find a kfc'
                  data-testid='start-order-click'
                  className='deepBlack font-bold button whiteButton blkBorder '
                  onClick={() => onStartOrderClick()}
                >
                  Find a KFC
                </ButtonComp>
              </div>
            )}
          </div>
          <div className='get-help-block mr5 mb-5'>
            <h3 className='header-text'>
              <span>{helpSectionCallDetails?.title}</span>
            </h3>
            <span className='section-text'>{helpSectionCallDetails?.description}</span>
            {!isMobile && (
              <span data-testid='contact-no-text' className='section-text font-bold deepBlack'>
                {helpSectionCallDetails?.contactNo}
              </span>
            )}
            {isMobile && (
              <a data-testid='contact-no-btn' href={`tel:${helpSectionCallDetails?.contactNo}`} className='anchorTags'>
                <div className='section-text mt-adjust ContactUsButton'>
                  <ButtonComp ariaLable='' className='deepBlack font-bold button whiteButton blkBorder '>
                    <ImageComponent
                      srcFile={helpSectionCallDetails?.icon}
                      alt='desktopImage'
                      className='Messageimage'
                    />
                    {helpSectionCallDetails?.buttonText}
                  </ButtonComp>
                </div>
              </a>
            )}
          </div>
          <div className='get-help-block mb-5'>
            <h3 className='header-text'>
              <span>{helpSectionContactDetails?.title}</span>
            </h3>
            <span className='section-text'>{helpSectionContactDetails?.description}</span>
            <div className='section-text mt-5 ContactUsButton'>
              <ButtonComp
                ariaLable='contact us'
                data-testid='contact-us-btn'
                className='deepBlack font-bold button whiteButton blkBorder '
                onClick={() => contactUs(helpSectionContactDetails?.linkUrl)}
              >
                <ImageComponent srcFile={helpSectionContactDetails?.desktopImage} alt=' ' className='Messageimage' />
                {helpSectionContactDetails?.linkText}
              </ButtonComp>
            </div>
          </div>
        </div>
      </>
      {faqSectionDetails.length > 0 && (
        <div className='faq-survey-section mb-5'>
          <div class='faq-survey-block  m1-adjust'>
            <h3 className='header-text'>{faqSectionDetails?.title}</h3>
            <span className='section-text'>{faqSectionDetails?.description}</span>
            <div className='faq-text-block'>
              {faqSectionDetails?.topics?.map(item => {
                return (
                  <ButtonComp
                    ariaLable={item}
                    tabindex='0'
                    data-testid='topic-item'
                    className='section-text'
                    onClick={FaqItemClick}
                  >
                    {item}
                  </ButtonComp>
                );
              })}
            </div>
            <span className='section-text mt-5'>
              <ButtonComp
                ariaLable='view all faq'
                data-testid='view-all-faq'
                className='deepBlack font-bold help-btn image-full-text-btn button whiteButton blkBorder'
                onClick={() => faqNavigate(faqSectionDetails?.linkUrl)}
              >
                {faqSectionDetails?.btnText}
              </ButtonComp>
            </span>
          </div>
          <div class='faq-survey-block  m-adjust'>
            <p className='header-text'>{surveyDetails?.title}</p>
            <div className='section-text faq-text-block'>{surveyDetails?.description}</div>
            <span className='section-text mt-5'>
              <a
                href={surveyDetails?.linkUrl}
                aria-hidden='true'
                tabindex='-1'
                target='_blank'
                className='anchorTags'
                rel='noopener noreferrer'
              >
                {surveyDetails?.btnText && (
                  <ButtonComp className='deepBlack font-bold help-btn image-full-text-btn button whiteButton blkBorder'>
                    {surveyDetails?.btnText}
                  </ButtonComp>
                )}
              </a>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
